import { render, staticRenderFns } from "./VoiceHintBar.vue?vue&type=template&id=0281a1d0&scoped=true&"
import script from "./VoiceHintBar.vue?vue&type=script&lang=js&"
export * from "./VoiceHintBar.vue?vue&type=script&lang=js&"
import style0 from "./VoiceHintBar.vue?vue&type=style&index=0&id=0281a1d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281a1d0",
  null
  
)

export default component.exports